import React from 'react'
import { Col, Row } from 'reactstrap'

const RSVFastEasyTest = () => {
  return (
    <div id='website-responsive'>
        <div className='left-padding6rem1 right-padding6rem1 py-4 py-md-4 py-lg-5'>
            <div className=''>
                <div className='fs-ss-30-2 text-montserrat text-ss-primary fw-700 lh-1-2 pb-2'>
                    Fast, Easy and Comprehensive RSV Test In Chicago
                </div>
                <hr className='hr-style my-md-2' style={{ width:'80px', marginTop:'2px', marginBottom:'4px'}}/>
       </div>

            <div className='py-2'>
                <div className='fs-ss-16 text-montserrat fw-600 text-ss-black' style={{ letterSpacing:'0.5px'}}>
                RSV testing near Chicago, united Lab Care provides a streamlined workflow and fast, comprehensive results.
                </div>
            </div>

            <div className='pt-md-5 pt-4'>
                <Row className=''>
                    <Col sm='12' md='4' xl='' className=''>
                    <div className='rsv-p1 rsv-bgc display-none' style={{ backgroundImage:'url("rsv-testing/RSV-Testing-widget-bg1.png")', backgroundSize:'', backgroundPosition:'center', backgroundRepeat:'no-repeat',padding:'' }}>
                        <div className=''>
                            <div className='fs-ss-38 text-montserrat text-white fw-500' style={{ marginTop:''}}>
                                1   
                            </div>
                        </div>
                        <div className='pb-1'>
                        <center>
                            <img src='rsv-testing/RSV-Testing-Workflow-icon1.png' alt='testing' className='' height='auto' width='80px' />
                        </center> 
                        </div>
                        <div className=''>
                            <div className='fs-ss-16 text-montserrat fw-500 text-ss-black' style={{ letterSpacing:'0.5px'}}>
                                <center>0.3mL of the nasopharyngeal swab in transport media or saline</center>
                            </div>
                        </div>
                    </div>
                    <div className='rsv-p1 display-block1' style={{ backgroundImage:'url("rsv-testing/RSV-Testing-widget-bg1.png")', backgroundSize:'contain', backgroundPosition:'center', backgroundRepeat:'no-repeat',padding:'' }}>
                        <div className='flex-center d-md-block'>
                            <div className='fs-ss-38-1 text-montserrat text-white fw-500' style={{ marginTop:'', marginLeft:'', marginRight:'8rem'}}>
                                1  
                            </div>
                        </div>
                        <div className='pb-1'>
                        <center>
                            <img src='rsv-testing/RSV-Testing-Workflow-icon1.png' alt='testing' className='' height='auto' width='80px' />
                        </center> 
                        </div>
                        <div className=''>
                            <div className='fs-ss-16 text-montserrat fw-500 text-ss-black' style={{ letterSpacing:'0.5px'}}>
                                <center>0.3mL of the<br/> nasopharyngeal<br/> swab in transport<br/> media or saline</center>
                            </div>
                        </div>
                    </div>
                    </Col>

                    <Col sm='12' md='4' xl='' className=''>
                    <div className='rsv-p2 rsv-bgc display-none' style={{ backgroundImage:'url("rsv-testing/RSV-Testing-widget-bg1.png")', backgroundSize:'', backgroundPosition:'center', backgroundRepeat:'no-repeat',padding:'' }}>
                    <div className=''>
                    <div className=''>
                            <div className='fs-ss-38 text-montserrat text-white fw-500' style={{ marginTop:''}}>
                                2   
                            </div>
                        </div>
                        <div className='pb-3'>
                        <center>
                            <img src='rsv-testing/RSV-Testing-Workflow-icon2.png' alt='testing' className='' height='auto' width='80px' />
                        </center>
                        </div>
                        <div className=''>
                            <div className='fs-ss-16 text-montserrat fw-500 text-ss-black' style={{ letterSpacing:'0.5px'}}>
                                <center>2 minutes of hands-on time</center>
                            </div>
                        </div>
                        </div>
                    </div>
                    <div className='rsv-p2 display-block1' style={{ backgroundImage:'url("rsv-testing/RSV-Testing-widget-bg1.png")', backgroundSize:'contain', backgroundPosition:'center', backgroundRepeat:'no-repeat',padding:'' }}>
                    <div className='mt-3 flex-center d-md-block'>
                            <div className='fs-ss-38-1 text-montserrat text-white fw-500' style={{ marginTop:'', marginLeft:'',  marginRight:'8rem'}}>
                                2   
                            </div>
                        </div>
                        <div className='pb-3'>
                        <center>
                            <img src='rsv-testing/RSV-Testing-Workflow-icon2.png' alt='testing' className='' height='auto' width='80px' />
                        </center>
                        </div>
                        <div className=''>
                            <div className='fs-ss-16 text-montserrat fw-500 text-ss-black' style={{ letterSpacing:'0.5px'}}>
                                <center>2 minutes of<br/> hands-on time</center>
                            </div>
                        </div>
                    </div>
                    </Col>

                    <Col sm='12' md='4' xl='' className=''>
                    <div className='rsv-p3 rsv-bgc display-none' style={{ backgroundImage:'url("rsv-testing/RSV-Testing-widget-bg1.png")', backgroundSize:'', backgroundPosition:'center', backgroundRepeat:'no-repeat',padding:'' }}>
                    <div className=''>
                            <div className='fs-ss-38 text-montserrat text-white fw-500' style={{ marginTop:''}}>
                                3   
                            </div>
                        </div>
                        <div className='pb-3'>
                        <center>
                            <img src='rsv-testing/RSV-Testing-Workflow-icon3.png' alt='testing' className='' height='auto' width='80px' />
                        </center>    
                        </div>
                        <div className=''>
                            <div className='fs-ss-16 text-montserrat fw-500 text-ss-black' style={{ letterSpacing:'0.5px'}}>
                               <center>Results in about 45 minutes</center>
                            </div>
                        </div>
                    </div>

                    <div className='rsv-p3 display-block1' style={{ backgroundImage:'url("rsv-testing/RSV-Testing-widget-bg1.png")', backgroundSize:'contain', backgroundPosition:'center', backgroundRepeat:'no-repeat',padding:'' }}>
                    <div className='flex-center d-md-block'>
                            <div className='fs-ss-38-1 text-montserrat text-white fw-500' style={{ marginTop:'', marginLeft:'',  marginRight:'8rem'}}>
                                3   
                            </div>
                        </div>
                        <div className='pb-3'>
                        <center>
                            <img src='rsv-testing/RSV-Testing-Workflow-icon3.png' alt='testing' className='' height='auto' width='80px' />
                        </center>    
                        </div>
                        <div className=''>
                            <div className='fs-ss-16 text-montserrat fw-500 text-ss-black' style={{ letterSpacing:'0.5px'}}>
                               <center>Results in about<br/> 45 minutes</center>
                            </div>
                        </div>
                    </div>
                    </Col>

                    <Col sm='12' md='6' xl='' className='pt-md-4 pt-lg-5 pt-xl-0'>
                    <div className='rsv-p4 rsv-bgc display-none' style={{ backgroundImage:'url("rsv-testing/RSV-Testing-widget-bg1.png")', backgroundSize:'', backgroundPosition:'center', backgroundRepeat:'no-repeat',padding:'' }}>
                    <div className=''>
                            <div className='fs-ss-38 text-montserrat text-white fw-500' style={{ marginTop:''}}>
                                4   
                            </div>
                        </div>
                        <div className='pb-3'>
                        <center>
                            <img src='rsv-testing/RSV-Testing-Workflow-icon4.png' alt='testing' className='' height='auto' width='80px' />
                        </center>
                        </div>
                        <div className=''>
                            <div className='fs-ss-16 text-montserrat fw-500 text-ss-black' style={{ letterSpacing:'0.5px'}}>
                                <center>Comprehensive results in a single report</center>
                            </div>
                        </div>
                    </div>

                    <div className='rsv-p4 display-block1' style={{ backgroundImage:'url("rsv-testing/RSV-Testing-widget-bg1.png")', backgroundSize:'contain', backgroundPosition:'center', backgroundRepeat:'no-repeat',padding:'',   }}>
                    <div className='flex-center d-md-block'>
                            <div className='fs-ss-38-1 text-montserrat text-white fw-500' style={{ marginTop:'', marginLeft:'', marginRight:'8rem'}}>
                                4   
                            </div>
                        </div>
                        <div className='pb-3'>
                        <center>
                            <img src='rsv-testing/RSV-Testing-Workflow-icon4.png' alt='testing' className='' height='auto' width='80px' />
                        </center>
                        </div>
                        <div className=''>
                            <div className='fs-ss-16 text-montserrat fw-500 text-ss-black' style={{ letterSpacing:'0.5px'}}>
                                <center>Comprehensive<br/> results in a single<br/> report</center>
                            </div>
                        </div>
                    </div>
                    </Col>

                    <Col sm='12' md='6' xl='' className='pt-md-4 pt-lg-5 pt-xl-0'>
                    <div className='rsv-p5 rsv-bgc display-none' style={{ backgroundImage:'url("rsv-testing/RSV-Testing-widget-bg1.png")', backgroundSize:'', backgroundPosition:'center', backgroundRepeat:'no-repeat',padding:'' }}>
                    <div className=''>
                            <div className='fs-ss-38 text-montserrat text-white fw-500' style={{ marginTop:''}}>
                                5   
                            </div>
                        </div>
                        <div className='pb-3 pe-2'>
                        <center>
                            <img src='rsv-testing/RSV-Testing-Workflow-icon5.png' alt='testing' className='' height='auto' width='80px' />
                        </center>   
                        </div>
                        <div className='pe-2'>
                            <div className='fs-ss-16 text-montserrat fw-500 text-ss-black' style={{ letterSpacing:'0.5px'}}>
                                <center>Improved Patient Management</center>
                            </div>
                        </div>
                    </div>

                    <div className='rsv-p5 display-block1' style={{ backgroundImage:'url("rsv-testing/RSV-Testing-widget-bg1.png")', backgroundSize:'contain', backgroundPosition:'center', backgroundRepeat:'no-repeat',padding:'', }}>
                    <div className='flex-center d-md-block'>
                            <div className='fs-ss-38-1 text-montserrat text-white fw-500' style={{ marginTop:'', marginLeft:'',  marginRight:'8rem' }}>
                                5   
                            </div>
                        </div>
                        <div className='pb-3 pe-2'>
                        <center>
                            <img src='rsv-testing/RSV-Testing-Workflow-icon5.png' alt='testing' className='' height='auto' width='80px' />
                        </center>   
                        </div>
                        <div className='pe-2'>
                            <div className='fs-ss-16 text-montserrat fw-500 text-ss-black' style={{ letterSpacing:'0.5px'}}>
                                <center>Improved Patient<br/> Management</center>
                            </div>
                        </div>
                    </div>
                    </Col>
                    
                </Row>
            </div>
        </div>
    </div>
  )
}

export default RSVFastEasyTest